import { AiIcon } from "./AiIcon";
import { cn } from "@/lib/utils";

/** The small "AI" action used next to text boxes: a sparkle, a short label, a spinner while it works */
export function AiButton({ busy, onClick, children, title, className, disabled }: { busy?: boolean; onClick: () => void; children?: React.ReactNode; title?: string; className?: string; disabled?: boolean }) {
  return (
    <button
      type="button"
      title={title}
      disabled={busy || disabled}
      onClick={onClick}
      className={cn("inline-flex h-7 items-center gap-1.5 rounded-md border border-[color-mix(in_oklch,var(--ai-from)_35%,transparent)] bg-accent px-2.5 text-xs font-medium text-accent-foreground hover:bg-accent/70 disabled:opacity-60", className)}
    >
      <AiIcon busy={busy} className="size-4" />
      {children}
    </button>
  );
}
